import { render } from "./OddsResults.vue?vue&type=template&id=7afaf399&scoped=true"
import script from "./OddsResults.vue?vue&type=script&lang=js"
export * from "./OddsResults.vue?vue&type=script&lang=js"

import "./OddsResults.vue?vue&type=style&index=0&id=7afaf399&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afaf399"]])

export default __exports__